import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, NavLink } from 'react-router-dom';
import DataTable from '@jcognard-actinvision/react-data-table-component';
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import Button from 'react-bootstrap/Button';
import { MoonLoader } from 'react-spinners';
import { getCurrentDate } from 'utils/dateFormat';
import Select from 'react-select';

import ReactPaginate from 'react-paginate';
import CurrencyFormat from 'react-currency-format';
import { useDispatch } from 'react-redux';
import { reportHandler, businessHandler, branchHandler } from '../../redux/handlers';
import moment from 'moment';

const optionsMap = {
  DINE_IN: 'ทานที่ร้าน',
  TAKEAWAY: 'กลับบ้าน',
  DELIVERY: 'จัดส่ง'
};
export function ReportBill() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [reportdata, setreportdata] = useState([]);
  const [searchdata, setSearchdata] = useState({
    branchID: '',
    posID: '',
    startDate: getCurrentDate('/'),
    endDate: getCurrentDate('/')
  });
  const { businessSlug } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [showResetSearch, setShowResetSearch] = useState(false);
  const [pos, setPos] = useState([]);
  const [branch, setBranch] = useState([]);
  const [posBranchObj, setPosBranchObj] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [optionsBranch, setOptionsBranch] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [optionsPos, setOptionsPos] = useState([]);
  const [businessId, setBusinessId] = useState(null);
  const [filterText, setFilterText] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  const firstLoad = useRef(true);

  const CurrencyFormatC = ({ val }) => {
    return (
      <CurrencyFormat
        value={val}
        decimalScale={2}
        fixedDecimalScale={true}
        displayType={'text'}
        thousandSeparator={true}
        prefix={''}
      />
    );
  };

  const columns = [
    {
      name: 'ลำดับ',
      selector: row => row.no,
      center: true,
      width: '80px'
    },
    {
      name: 'วันที่/เวลา',
      selector: row => row.date,
      width: '170px',
      footerContent: rows => {
        return 'รวมบิล';
      }
    },
    {
      name: 'ประเภทบิล',
      selector: row => row.type,
      width: '135px',
      footerContent: (rows, datas) => {
        return (
          <>
            <div>จำนวนบิล {rows.length} บิล</div>
          </>
        );
      }
    },
    {
      name: 'เลขที่ใบเสร็จ',
      selector: row => row.receipt_code,
      width: '155px',
      cell: (row, index, column, id) => (
        <NavLink
          to={`/${businessSlug}/report/bill/detail/${row.id}`}
          style={{
            color: '#066AFF',
            fontWeight: 500,
            textDecoration: 'underline'
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.receipt_code}
        </NavLink>
      )
    },
    {
      name: 'ราคาสุทธิรับชำระ',
      selector: row => row.final_amount,
      width: '155px',
      cell: (row, index, column, id) => (
        <div style={{ color: '#2DC76D', fontWeight: 500 }}>
          <CurrencyFormatC val={row.final_amount} />
        </div>
      ),
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.final_amount.toFixed(2) || 0), 0);
        return (
          <div style={{ color: '#2DC76D', fontWeight: 500 }}>
            <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />
          </div>
        );
      }
    },
    {
      name: 'ราคารวมก่อนส่วนลด',
      selector: row => row.total_before_discount,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.total_before_discount} />,
      width: '150px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.total_before_discount.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'ส่วนลดท้ายบิล',
      selector: row => row.discount_amount,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.discount_amount} />,
      width: '140px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.discount_amount.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'ส่วนลดจากโปรโมชั่น',
      selector: row => row.discount_promotion,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.discount_promotion} />,
      width: '150px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.discount_promotion.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'ราคาหลังหักส่วนลด',
      selector: row => row.total_after_discount,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.total_after_discount} />,
      width: '150px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.total_after_discount.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: (
        <div className="lh-sm ">
          <div>Service</div>
          <div className="text-center pt-1">Charge</div>
        </div>
      ),
      selector: row => row.service_charge,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.service_charge} />,
      width: '120px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.service_charge.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'ค่าธรรมเนียมบัตรเครดิต',
      selector: row => row.credit_card_fee,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.credit_card_fee} />,
      width: '170px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.credit_card_fee.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total || '0').toFixed(2)} />;
      }
    },
    {
      name: 'มูลค่าสินค้า(ไม่มีภาษี)',
      selector: row => row.price_without_vat,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.price_without_vat} />,
      width: '170px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.price_without_vat.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'มูลค่าสินค้า(มีภาษี)',
      selector: row => row.price_with_vat,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.price_with_vat} />,
      width: '170px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.price_with_vat.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'ภาษีมูลค่าเพิ่ม',
      selector: row => row.vat,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.vat} />,
      width: '120px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.vat.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'กำไรปัดเศษ',
      selector: row => row.loss_rounded,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.loss_rounded} />,
      width: '120px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.loss_rounded.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'ประเภทการชำระเงิน',
      selector: row => row.payment_method,
      center: true,
      width: '200px'
    },
    {
      name: 'เงินสดรับ',
      selector: row => row.cash_amount,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.cash_amount} />,
      width: '120px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.cash_amount.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'เงินทอน',
      selector: row => row.change_amount,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.change_amount} />,
      width: '120px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.change_amount.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'เงินสด',
      selector: row => row.cash_after_cash_out,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.cash_after_cash_out} />,
      width: '120px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.cash_after_cash_out.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'เงินโอน',
      selector: row => row.transfer_amount,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.transfer_amount} />,
      width: '120px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.transfer_amount.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'บัตรเครดิต',
      selector: row => row.credit_card_amount,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.credit_card_amount} />,
      width: '120px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.credit_card_amount.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: (
        <div className="lh-sm ">
          <div className="text-center">Delivery</div>
          <div className="text-center pt-1">ผ่านผู้ให้บริการ</div>
        </div>
      ),
      selector: row => row.delivery_amount,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.delivery_amount} />,
      width: '120px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.delivery_amount.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'ส่วนลดคะแนน',
      selector: row => row.discount_points,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.discount_points} />,
      width: '170px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.discount_points.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    },
    {
      name: 'ตรวจสอบ',
      selector: row => row.amount_check,
      center: true,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.amount_check} />,
      width: '150px',
      footerContent: rows => {
        const total = rows.reduce((val, row) => val + Number(row.amount_check.toFixed(2) || 0), 0);
        return <CurrencyFormatC val={Number(total.toFixed(2) || '0')} />;
      }
    }
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: '52px'
      }
    },
    headCells: {
      style: {
        paddingLeft: '15px',
        paddingRight: '15px',
        color: 'rgba(76, 78, 100, 0.87)',
        fontFamily: 'Sarabun',
        fontSize: '14px',
        background: ' #F5F5F7',
        paddingTop: '5px',
        paddingBottom: '5px',
        fontWeight: '500'
      }
    },
    cells: {
      style: {
        paddingLeft: '15px',
        paddingRight: '15px',
        color: 'rgba(76, 78, 100, 0.87)',
        fontFamily: 'Sarabun',
        background: ' #FFF',
        fontSize: '14px',
        fontWeight: '300'
      }
    },
    expanderRow: {
      style: {
        minHeight: '52px'
      }
    },
    pagination: {
      style: {
        borderBottomRightRadius: '0.75rem',
        borderBottomLeftRadius: '0.75rem'
      }
    }
  };

  const paginationComponentOptions = {
    rowsPerPageText: 'จำนวนรายการต่อหน้า',
    rangeSeparatorText: 'of',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All'
  };

  const formatData = async rawData => {
    const updateFormat = rawData?.map((item, index) => {
      const date = moment(item?.created_at);
      const currentDate = date.format('DD/MM/YYYY');
      const currentTime = date.format('HH:mm:ss');
      return {
        id: item.id,
        no: index + 1,
        date: `${currentDate} ${currentTime}`,
        type: optionsMap[item.order_type] || item.order_type,
        receipt_code: item.receipt_no || '',
        total_before_discount: item.total_before_discount || 0,
        discount_amount: item.discount_amount || 0,
        discount_points: item.discount_points || 0,
        discount_promotion: item.discount_promotion || 0,
        total_after_discount: item.total_after_discount || 0,
        service_charge: item.service_charge || 0,
        credit_card_fee: item.credit_card_fee || 0,
        price_without_vat: item.price_without_vat || 0,
        price_with_vat: item.price_with_vat || 0,
        vat: item.vat || 0,
        final_amount: item.final_amount || 0,
        loss_rounded: item.loss_rounded || 0,
        payment_method: item.payment_method || 'เงินสด',
        cash_amount: parseFloat(item.cash_amount) || 0,
        change_amount: item.change_amount || 0,
        cash_after_cash_out: item.cash_after_cash_out || 0,
        transfer_amount: parseFloat(item.transfer_amount) || 0,
        credit_card_amount: parseFloat(item.credit_card_amount) || 0,
        delivery_amount: item.delivery_amount || 0,
        amount_check: item.amount_check || 0
      };
    });

    updateFormat.forEach((item, index) => {
      item.no = index + 1;
    });

    return updateFormat;
  };

  useEffect(() => {
    if (reportdata.length > 0) {
      let items = reportdata;
      if (filterText) {
        items = reportdata.filter(item => {
          return (
            (item.type && item.type.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.receipt_code && item.receipt_code.toLowerCase().includes(filterText.toLowerCase()))
          );
        });
      }

      setFilteredItems(items);
      setTotalItems(items.length);
    }
  }, [reportdata, filterText]);

  const handleSearch = async () => {
    setIsLoading(true);

    // แปลงวันที่แบบง่าย ๆ ด้วย moment
    const startDate = moment(searchdata.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const endDate = moment(searchdata.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD');

    // ตรวจสอบว่าวันที่ valid หรือไม่
    if (!moment(startDate).isValid() || !moment(endDate).isValid()) {
      console.error('วันที่ไม่ถูกต้อง');
      setIsLoading(false);
      return;
    }

    if (firstLoad.current === true) {
      firstLoad.current = false;
    }

    const params = {
      branchId: posBranchObj.branchId,
      branchPosId: posBranchObj.posId,
      page: 1,
      perPage: 10000,
      sortBy: 'created_at',
      sortOrder: 'desc',
      startDate: startDate,
      endDate: endDate
    };

    try {
      const responseData = await dispatch(reportHandler.getBillReport(businessSlug, params));
      const data = await formatData(responseData.data);
      setTotalItems(data.length);
      setreportdata(data);
      setFilteredItems(data);
      setCurrentPage(1);
      setShowResetSearch(true);
    } catch (error) {
      console.error('Error fetching report data:', error);
      setreportdata([]);
      setFilteredItems([]);
      setTotalItems(0);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = () => {
    // แปลงวันที่แบบง่าย ๆ
    const formattedStartDate = moment(searchdata.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const formattedEndDate = moment(searchdata.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD');

    const params = {
      branchId: posBranchObj?.branchId || null,
      branchPosId: posBranchObj?.posId || null,
      sortBy: 'created_at',
      sortOrder: 'desc',
      startDate: formattedStartDate,
      endDate: formattedEndDate
    };

    if (params.branchId && params.branchPosId) {
      dispatch(reportHandler.getBillReportExcel(businessSlug, params, `${formattedStartDate}ถึง${formattedEndDate}`));
    } else {
      console.error('กรุณาเลือกสาขาและ POS ก่อนดาวน์โหลดรายงาน');
    }
  };

  const resetFilter = () => {
    setShowResetSearch(false);
    setreportdata([]);
    setFilteredItems([]);
    setBranchSelected([]);
    setFilterText('');
    setCurrentPage(1);
    setBranch([]);
    setPos([]);
    setPosBranchObj(null);
    setSearchdata({
      branchID: '',
      posID: '',
      startDate: getCurrentDate('/'),
      endDate: getCurrentDate('/')
    });
  };

  const formatBranch = (rawData, isBranch = false) => {
    let updateBranch = [];
    if (isBranch) {
      updateBranch = rawData?.map(item => ({
        value: item.id,
        label: item.name
      }));
    } else {
      updateBranch = rawData?.map(item => ({
        value: item.id,
        label: item.branch_name
      }));
    }
    return updateBranch;
  };

  const [branchSelected, setBranchSelected] = useState([]);

  const handlerSelectBranchChange = async branch => {
    setBranch(branch);
    setPos([]);
    if (branch) {
      const data = await dispatch(branchHandler.getPOSByBranchId(branch.value));
      if (data) {
        const updateFormat = formatBranch(data?.branchPOS, true);
        setOptionsPos(updateFormat);
      }
      setPosBranchObj({ branchId: branch.value, posId: null });
    } else {
      setOptionsPos([]);
      setPosBranchObj(null);
    }
  };

  const handlerSelectPosChange = pos => {
    setPos(pos);
    if (pos && posBranchObj) {
      let temp = { ...posBranchObj };
      temp.posId = pos.value;
      setPosBranchObj(temp);
    }
  };

  const handleApply = (event, picker) => {
    setSearchdata(prev => ({
      ...prev,
      startDate: picker.startDate.format('DD/MM/YYYY'),
      endDate: picker.endDate.format('DD/MM/YYYY')
    }));
  };

  const getPaginatedData = () => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredItems.slice(startIndex, endIndex);
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);
  };

  useEffect(() => {
    async function getInitBusinessData() {
      const data = await dispatch(businessHandler.getBusinessBySlug(businessSlug));
      if (data) {
        setBusinessId(data.business.id);
      }
    }
    getInitBusinessData();
  }, []);

  useEffect(() => {
    async function fetchAllBranch() {
      if (businessId) {
        const data = await dispatch(businessHandler.getBusinessListBranch(businessId));
        const formatedData = formatBranch(data.business.branch.filter(e => e.is_status));
        setOptionsBranch(formatedData);
      }
    }
    fetchAllBranch();
  }, [businessId]);

  return (
    <div>
      <nav aria-label="breadcrumb" className="mt-2">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item ">
            <a href="#" className="tc-7  text-decoration-none">
              รายงาน
            </a>
          </li>
          <li className="breadcrumb-item active tc-1 " aria-current="page">
            {' '}
            ยอดขายรายบิล{' '}
          </li>
        </ol>
      </nav>

      <div className="card card-st-2 mb-4">
        <div className="card-body  py-4">
          <div className="fw-bold mb-3">ค้นหาขั้นสูง</div>
          <div className="row items-center">
            <div className="col-xl-2 col-lg-3 col-2">
              <Select
                as="select"
                name="branch"
                onChange={e => handlerSelectBranchChange(e)}
                className={`w-100 select-st-1 sm pd`}
                options={optionsBranch}
                placeholder="เลือกสาขา"
                isClearable={true}
                value={branch}
              />
            </div>
            <div className="col-xl-2 col-lg-3 col-2">
              <Select
                as="select"
                name="pos"
                onChange={e => handlerSelectPosChange(e)}
                className="w-100 select-st-1 sm pd"
                options={optionsPos}
                placeholder="เลือก POS"
                isDisabled={optionsPos.length === 0}
                value={pos}
              />
            </div>

            <div className="col-xl-3 col-lg-3 col-2">
              <DateRangePicker
                initialSettings={{
                  startDate: searchdata.startDate,
                  endDate: searchdata.endDate,
                  locale: {
                    format: 'DD/MM/YYYY'
                  }
                }}
                onApply={handleApply}
              >
                <input type="text" className="form-control iconcalendar-right" />
              </DateRangePicker>
            </div>
            <div className="col-auto">
              <Button
                type="button"
                className="btn-st-3 flex justify-center items-center"
                style={{ width: '120px', height: '40px' }}
                onClick={handleSearch}
                disabled={posBranchObj === null || posBranchObj.branchId === null || posBranchObj.posId === null}
              >
                ค้นหา
              </Button>
            </div>
            {showResetSearch && (
              <div className="col-auto">
                <Button
                  type="button"
                  className="bg-orange-400 flex justify-center items-center hover:bg-orange-300"
                  style={{ width: '150px', height: '40px', border: 0 }}
                  onClick={resetFilter}
                >
                  ล้างการค้นหา
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      {isLoading && (
        <div className="w-full h-screen flex justify-center items-start">
          <MoonLoader
            color="#2DC76D"
            loading={isLoading}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
            className="mt-40"
          />
        </div>
      )}
      {showResetSearch && (
        <div className="card card-st-2 mb-5">
          <div className="card-body p-0 rounded-xl">
            <div className="d-flex align-items-center px-4 mb-4 pt-4 rd-0">
              <button className="btn btn-export-st-1 me-auto" onClick={() => handleExport()}>
                Export
              </button>
              <div>
                <input
                  type="text"
                  className="form-control form-st-4"
                  placeholder="ค้นหา"
                  value={filterText}
                  onChange={e => setFilterText(e.target.value)}
                />
              </div>
            </div>
            <DataTable
              columns={columns}
              data={getPaginatedData()}
              customStyles={customStyles}
              pagination
              paginationServer
              footer={getPaginatedData()}
              paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
              paginationPerPage={rowsPerPage}
              paginationDefaultPage={currentPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              paginationComponent={props => (
                <CustomPagination
                  rowCount={filteredItems.length}
                  rowsPerPage={rowsPerPage}
                  currentPage={currentPage}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerRowsChange}
                />
              )}
              paginationComponentOptions={paginationComponentOptions}
              showFooter
              noDataComponent={<div className="p-4 text-center">ไม่พบข้อมูล</div>}
            />
          </div>
        </div>
      )}
    </div>
  );
}

const CustomPagination = ({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }) => {
  const count = Math.ceil(rowCount / rowsPerPage);
  const pageSizeOptions = [5, 10, 25, 50, 100];

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-end mx-0 pt-3 pb-5"
        style={{ borderTop: '1px solid #e0e0e0' }}
      >
        <div className="fs-12 d-flex justify-content-start me-5" style={{ color: '#4C4E64' }}>
          <p>
            <span className="me-2">จำนวนรายการต่อหน้า</span>
            <select
              className="form-select form-select-sm d-inline-block me-4"
              style={{ width: 'auto', minWidth: '70px' }}
              value={rowsPerPage}
              onChange={e => {
                onChangeRowsPerPage(Number(e.target.value), 1);
              }}
            >
              {pageSizeOptions.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {rowCount === 0
              ? 0
              : currentPage * rowsPerPage - rowsPerPage + 1 > rowCount
              ? rowCount
              : currentPage * rowsPerPage - rowsPerPage + 1}
            <span className="mx-1 fs-18">-</span>
            {currentPage * rowsPerPage > rowCount ? rowCount : currentPage * rowsPerPage}
            <span className="mx-1">of</span> {rowCount}
          </p>
        </div>

        <div className="d-flex justify-content-end">
          <ReactPaginate
            previousLabel={<i className="icon-prev"></i>}
            nextLabel={<i className="icon-next"></i>}
            forcePage={currentPage !== 0 ? currentPage - 1 : 0}
            onPageChange={page => {
              onChangePage(page.selected + 1);
            }}
            pageCount={count || 1}
            breakLabel={'...'}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            activeClassName={'active'}
            pageClassName={'page-item'}
            nextLinkClassName={'page-link'}
            nextClassName={'page-item next'}
            previousClassName={'page-item prev'}
            previousLinkClassName={'page-link'}
            pageLinkClassName={'page-link'}
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName={'pagination react-paginate pagination-sm justify-content-end pr-1 mt-1'}
            disabledClassName={'disabled'}
          />
        </div>
      </div>
    </>
  );
};
